import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { PopupData } from 'webapp-types';
import type { Theme } from 'webapp/enums/enums';
import { AttachPosition } from 'webapp/enums/enums';

import FormComparePopupComponent from 'webapp/components/form/compare/popup';
import FormSelectWithPopupAsDropdownComponent from 'webapp/components/form/select-with-popup-as-dropdown';

import type DsCompare from 'webapp/models-custom/ds-compare';
import type MetricLimitations from 'webapp/models-custom/metric-limitations';

interface Args {
	metricLimitations: MetricLimitations;
	onChange: (compare: DsCompare) => void;
	compare?: DsCompare;
	theme?: Theme | string;
	size?: string;
	placeholder?: string;
	isDisabled?: boolean;
	exceptionIds?: string[];
	showOtherMetricCompare?: boolean;
	extraClass?: string;
	trackingOrigin?: string;
	popupOffset?: number;
}

export default class FormCompareDropdownComponent extends Component<Args> {
	get compare() {
		return this.args.compare || this.args.metricLimitations?.compare || undefined;
	}

	// ------ for select dropdown ----- //

	get selected() {
		return this.compare?.selectionId;
	}

	get options() {
		// only need to update options when either compare text has changed
		// or compare title has changed (for x units before selections)

		// since we will only see the currently selected option we can show same title on all for easier logic
		const label = this.compare?.titleUX || this.compare?.title || '';

		const options = this.args.metricLimitations.predefinedCompares.map((compare) => {
			return {
				value: compare.selectionId,
				label: label || compare.title,
			};
		});

		return options;
	}

	@action
	doNothing() {
		// changes on this dropdown will go through the popup
		// since the dropdown cannot even be opened
	}

	// ------ for popup ----- //

	popupComponent = FormComparePopupComponent;

	popupClass = 'popup-cdr popup-cdr-compare';

	popupAttachPosition = AttachPosition.START;
	popupalignEdgeWithAttachTo = true;

	get exceptionIds() {
		// won't be showing these categories in the popup
		return this.args.exceptionIds || [];
	}

	@action
	getPopupProps() {
		const props: PopupData.Form.Compare = {
			compare: this.compare,
			metricLimitations: this.args.metricLimitations,
			exceptionIds: this.exceptionIds,
			showOtherMetricCompare: this.args.showOtherMetricCompare,
			trackingOrigin: this.args.trackingOrigin,
			onChange: this.args.onChange,
		};

		return props;
	}
	<template>
		<FormSelectWithPopupAsDropdownComponent
			@selected={{this.selected}}
			@options={{this.options}}
			@onChange={{this.doNothing}}
			@isNumeric={{false}}
			@placeholder={{@placeholder}}
			@isDisabled={{@isDisabled}}
			@theme={{@theme}}
			@size={{@size}}
			@extraClass={{@extraClass}}
			@popupComponent={{this.popupComponent}}
			@popupClass={{this.popupClass}}
			@getPopupProps={{this.getPopupProps}}
			@popupOffset={{1}}
			@popupAttachPosition={{this.popupAttachPosition}}
			@popupalignEdgeWithAttachTo={{this.popupalignEdgeWithAttachTo}}
		/>
	</template>
}
